// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useLoader } from "../../../../context/LoaderProvider.jsx";
// const Management5 = () => {
//   const [formData, setFormData] = useState({
//     type: "",
//     description: "",

//     gole
//       : "",
//     startDate: "",
//     endDate: "",
//     discount: "",
//     image: "",
//   });

//   const [couponRequests, setCouponRequests] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const isMobile = window.innerWidth <= 768;
//   const [payNowModal, setPayNowModal] = useState(false);
//   const { showLoader, hideLoader } = useLoader();

//   const [loading, setLoading] = useState(true);

//   const tdStyle = {
//     border: "1px solid #ccc",
//     padding: "10px",
//     textAlign: "left",
//   };


//   const [payNowAmount, setPayNowAmount] = useState(0);
//   const [loadingPayNow, setLoadingPayNow] = useState(false);
//   const [selectedCouponId, setSelectedCouponId] = useState(null);


//   const handleRazorpayPayment = async () => {
//     try {
//       const vendorId = localStorage.getItem("vendorId");
//       const token = localStorage.getItem("authToken");

//       // ✅ Step 0: Fetch vendor details (ownerName, email, mobileNumber)
//       const vendorRes = await axios.get(
//         `https://backend.maamaas.com/food/api/vendors/${vendorId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       const vendorData = vendorRes.data;
//       const vendorMobile =
//         vendorData?.mobileNumber && vendorData.mobileNumber.toString().trim() !== ""
//           ? vendorData.mobileNumber.toString()
//           : "9999999999"; // fallback if missing

//       const vendorName =
//         vendorData?.ownerName && vendorData.ownerName.trim() !== ""
//           ? vendorData.ownerName
//           : "Vendor";

//       const vendorEmail =
//         vendorData?.email && vendorData.email.trim() !== ""
//           ? vendorData.email
//           : "vendor@example.com";

//       // ✅ Step 1: Prepare payment details
//       const payNowAmountInPaise = Math.round(payNowAmount);

//       const username = "rzp_live_RU5whSMu9rPV7s"; // Razorpay test key
//       const password = "khRC0vtSHCGHktyu62yekZp0"; // Razorpay test secret
//       const basicAuth = btoa(`${username}:${password}`);

//       // ✅ Step 2: Create Razorpay Order via backend
//       const createOrderRes = await axios.post(
//         "https://backend.maamaas.com/subscription/api/user/create-order",
//         {
//           amount: payNowAmountInPaise,
//           currency: "INR",
//           vendorId,
//         },
//         {
//           headers: {
//             Authorization: `Basic ${basicAuth}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const { orderId } = createOrderRes.data;
//       if (!orderId) throw new Error("Order ID not received from backend");

//       // ✅ Step 3: Open Razorpay Checkout
//       const options = {
//         key: username,
//         amount: payNowAmountInPaise,
//         currency: "INR",
//         name: "Maamaa's",
//         description: "Coupon Payment",
//         order_id: orderId,
//         handler: async (response) => {
//           const paymentId = response.razorpay_payment_id;
//           const razorpayOrderId = response.razorpay_order_id;

//           if (!paymentId || !razorpayOrderId) {
//             alert("⚠️ Payment ID or Order ID missing.");
//             return;
//           }

//           try {
//             // ✅ Step 4: Capture payment via backend
//             await axios.post(
//               "https://backend.maamaas.com/subscription/api/user/capture",
//               {
//                 paymentId,
//                 amount: payNowAmountInPaise,
//                 currency: "INR",
//                 vendorId,
//               },
//               {
//                 headers: { Authorization: `Basic ${basicAuth}` },
//               }
//             );

//             // ✅ Step 5: Update internal backend
//             await axios.put(
//               `https://backend.maamaas.com/food/api/vendor/coupon/updatePayment`,
//               {},
//               {
//                 params: {
//                   vendorRequirementCouponId: selectedCouponId,
//                   transactionId: paymentId,
//                   orderId: razorpayOrderId,
//                 },
//                 headers: { Authorization: `Bearer ${token}` },
//               }
//             );

//             alert("Payment successful and updated!");
//             window.location.reload();
//             setPayNowModal(false);
//           } catch (captureError) {
//             console.error("❌ Payment capture failed:", captureError);
//             alert("Payment saved but capture failed.");
//           }
//         },
//         prefill: {
//           name: vendorName, // ✅ ownerName from backend
//           email: vendorEmail, // ✅ email from backend
//           contact: vendorMobile, // ✅ mobileNumber from backend (no +91)
//         },
//         theme: { color: "#b15cd6" },
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.open();
//     } catch (error) {
//       console.error("❌ Razorpay error:", error);
//       alert("Payment failed to initialize.");
//     }
//   };


//   const openPayNowModal = async (couponId) => {
//     try {
//       setLoadingPayNow(true);
//       const token = localStorage.getItem("authToken");

//       const response = await axios.get(
//         `https://backend.maamaas.com/food/api/vendor/coupon/get/${couponId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       setPayNowAmount(response.data.amount || 0);
//       setSelectedCouponId(couponId); // ✅ save for payment update
//       setPayNowModal(true);
//     } catch (error) {
//       console.error("❌ Error fetching coupon amount:", error);
//       alert("Failed to fetch coupon amount");
//     } finally {
//       setLoadingPayNow(false);
//     }
//   };



//   // ✅ Fetch coupons on mount
//   useEffect(() => {
//     const fetchCoupons = async () => {
//       try {
//         showLoader();
//         const token = localStorage.getItem("authToken");
//         const vendorId = localStorage.getItem("vendorId");

//         if (!token || !vendorId) {
//           alert("Missing vendor session. Please log in again.");
//           setLoading(false);
//           return;
//         }

//         const response = await axios.get(
//           `https://backend.maamaas.com/food/api/vendor/coupon/getByVendor/${vendorId}`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               Accept: "*/*",
//             },
//           }
//         );

//         // console.log("✅ Coupons fetched:", response.data);

//         setCouponRequests(response.data || []);
//       } catch (error) {
//         console.error("❌ Error fetching coupons:", error);
//         alert("Failed to fetch coupon requests");
//       } finally {
//         setLoading(false);
//         hideLoader();
//       }
//     };

//     fetchCoupons();
//   }, []);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };


//   const handleImageUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onloadend = () => {
//       let result = reader.result;

//       // ✅ Ensure only base64 part (after comma)
//       const base64Data = result.split(",")[1];

//       setFormData((prev) => ({
//         ...prev,
//         image: base64Data, // pure base64 string only
//       }));
//     };
//     reader.readAsDataURL(file);
//   };


//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       let authtoken = localStorage.getItem("authToken");
//       let vendorId = localStorage.getItem("vendorId");

//       if (!authtoken || !vendorId) {
//         alert("Missing vendor session. Please log in again.");
//         return;
//       }

//       // ✅ Construct payload with all fields
//       const newRequest = {
//         vendorRequirementCouponId: 0,
//         couponCode: formData.type?.toUpperCase().slice(0, 6) || "DEFAULT",
//         discount: Number(formData.discount) || 0,
//         startDate: new Date(formData.startDate).toISOString(),
//         endDate: new Date(formData.endDate).toISOString(),
//         description: formData.description || "",
//         gole: formData.gole || "",
//         amount: 0, // default if not needed
//         paymentStatus: "PENDING",
//         vendorId: "null",
//         transactionId: "string",
//         orderId: "string", // default placeholder
//         image: formData.image || "", // ✅ base64 string
//       };

//       // console.log("📤 Sending payload:", newRequest);

//       const response = await axios.post(
//         `https://backend.maamaas.com/food/api/vendor/coupon/add/${vendorId}`,
//         newRequest,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${authtoken}`,
//           },
//         }
//       );

//       // console.log("✅ Coupon submitted:", response.data);
//       window.location.reload();
//       // Reset
//       setFormData({
//         type: "",
//         description: "",
//         goal: "",
//         startDate: "",
//         endDate: "",
//         discount: "",
//         image: "",
//       });
//       setShowModal(false);
//     } catch (error) {
//       console.error("❌ Error submitting coupon:", error.response?.data || error.message);
//       alert("Failed to submit coupon. Please check server logs.");
//     }
//   };




//   return (
//     <div
//       style={{
//         // padding: '20px',
//         maxWidth: '1200px',
//         // margin: isMobile ? '38px 0 0 -29px' : 'auto',
//         boxSizing: 'border-box',
//         position: 'relative',
//         width: '100%',
//       }}
//     >
//       <div style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         marginBottom: '20px'
//       }}>
//         <button
//           style={{
//             padding: '10px 16px',
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             border: 'none',
//             borderRadius: '6px',
//             cursor: 'pointer',
//             fontWeight: 'bold',
//             fontSize: 'clamp(12px, 2vw, 14px)',
//           }}
//           onClick={() => setShowModal(true)}
//         >
//           + Request Coupon
//         </button>
//       </div>

//       {/* Table Section */}
//       <div style={{
//         marginTop: '-15px',
//         overflowX: 'auto',   // Horizontal scroll
//         overflowY: 'auto',   // Vertical scroll
//         width: '100%',
//         height: '500px',
//         scrollbarWidth: 'thin', // For Firefox
//         msOverflowStyle: 'auto', // For IE/Edge
//       }}
//       >
//         <div style={{
//           minWidth: '800px',
//           width: '100%'
//         }}>
//           <table
//             style={{
//               width: "100%",
//               borderCollapse: "collapse",
//               backgroundColor: "white",
//               border: "1px solid rgba(204, 204, 204, 1)",
//               marginTop:"0px",
//             }}
//           >
//             <thead>
//               <tr>
//                 {[
//                   "S.No",
//                   "Type",
//                   "Description",
//                   "Image",
//                   "Goal",
//                   "Start Date",
//                   "End Date",
//                   "Discount",
//                   "Amount",
//                   "Status",
//                   "Action",
//                 ].map((head, i) => (
//                   <th
//                     key={i}
//                     style={{
//                       border: "1px solid #ccc",
//                       padding: "10px",
//                       backgroundColor: "#b15cd6",
//                       fontSize: "clamp(10px, 2vw, 14px)",
//                       textAlign: "left",
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     {head}
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {loading ? (
//                 <tr>
//                   <td colSpan="9" style={{ textAlign: "center", padding: "12px" }}>
//                     Loading...
//                   </td>
//                 </tr>
//               ) : couponRequests.length === 0 ? (
//                 <tr>
//                   <td colSpan="9" style={{ textAlign: "center", padding: "12px" }}>
//                     No requests yet.
//                   </td>
//                 </tr>
//               ) : (
//                 couponRequests.map((request, index) => (
//                   <tr key={index}>
//                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
//                       {index + 1}
//                     </td>
//                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
//                       {request.couponCode}
//                     </td>
//                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
//                       {request.description}
//                     </td>
//                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
//                       {request.image ? (
//                         <img
//                           src={`data:image/png;base64,${request.image}`} // 👈 show base64 as image
//                           alt="Coupon"
//                           style={{
//                             width: "60px",
//                             height: "60px",
//                             objectFit: "cover",
//                             borderRadius: "6px",
//                             border: "1px solid #ccc",
//                           }}
//                         />
//                       ) : (
//                         "No Image"
//                       )}
//                     </td>

//                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
//                       {request.gole || "N/A"}
//                     </td>
//                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
//                       {request.startDate ? new Date(request.startDate).toLocaleDateString("en-GB") : "-"}
//                     </td>
//                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
//                       {request.endDate ? new Date(request.endDate).toLocaleDateString("en-GB") : "-"}
//                     </td>

//                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
//                       {request.discount}%
//                     </td>
//                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
//                       {request.amount}
//                     </td>
//                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
//                       {request.paymentStatus || "Pending"}
//                     </td>
//                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
//                       {request.paymentStatus === "PAID" ? (
//                         <button
//                           style={{
//                             backgroundColor: "gray",
//                             color: "white",
//                             border: "1px solid #ddd", // ✅ added border
//                             padding: "6px 12px",
//                             borderRadius: "6px",
//                             cursor: "not-allowed",
//                           }}
//                           disabled
//                         >
//                           Paid
//                         </button>
//                       ) : (
//                         <button
//                           style={{
//                             backgroundColor: "#b15cd6",
//                             color: "white",
//                             border: "1px solid #b15cd6", // ✅ added border matching button
//                             padding: "6px 12px",
//                             borderRadius: "6px",
//                             cursor: "pointer",
//                           }}
//                           onClick={() => openPayNowModal(request.vendorRequirementCouponId)}
//                         >
//                           Pay Now
//                         </button>
//                       )}
//                     </td>




//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>


//       {payNowModal && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             height: '100vh',
//             width: '100vw',
//             backgroundColor: 'rgba(0,0,0,0.5)',
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             zIndex: 1000,
//           }}
//         >
//           <div
//             style={{
//               backgroundColor: '#fff',
//               padding: '20px',
//               borderRadius: '10px',
//               width: '90%',
//               maxWidth: '400px',
//               boxSizing: 'border-box',
//             }}
//           >
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <h3 style={{ fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: 'bold' }}>Pay Now</h3>
//               <button
//                 style={{
//                   background: 'transparent',
//                   border: 'none',
//                   fontSize: '18px',
//                   cursor: 'pointer',
//                 }}
//                 onClick={() => setPayNowModal(false)}
//               >
//                 ✕
//               </button>
//             </div>

//             <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
//               {loadingPayNow ? (
//                 <p>Loading amount...</p>
//               ) : (
//                 <label style={labelStyle}>
//                   Amount
//                   <input
//                     type="number"
//                     value={payNowAmount}
//                     readOnly
//                     style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
//                   />
//                 </label>
//               )}

//               <button
//                 style={{
//                   padding: '12px',
//                   backgroundColor: '#1976d2',
//                   color: 'white',
//                   fontWeight: 'bold',
//                   border: 'none',
//                   borderRadius: '6px',
//                   cursor: 'pointer',
//                   width: 'fit-content',
//                   fontSize: 'clamp(12px, 2vw, 14px)'
//                 }}
//                 onClick={handleRazorpayPayment} // ✅ call payment function
//               >
//                 Proceed to Pay
//               </button>

//             </div>
//           </div>
//         </div>
//       )}



//       {/* Modal Popup */}
//       {showModal && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             height: '100vh',
//             width: '100vw',
//             backgroundColor: 'rgba(0,0,0,0.5)',
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             zIndex: 1000,
//           }}
//         >
//           <div
//             style={{
//               backgroundColor: '#fff',
//               padding: '20px',
//               borderRadius: '10px',
//               width: '90%',
//               maxWidth: '600px',
//               maxHeight: '90vh',
//               overflowY: 'auto',
//               boxSizing: 'border-box',
//             }}
//           >
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <h3 style={{ fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: 'bold' }}>Request a Coupon</h3>
//               <button
//                 style={{
//                   background: 'transparent',
//                   border: 'none',
//                   fontSize: '18px',
//                   cursor: 'pointer',
//                 }}
//                 onClick={() => setShowModal(false)}
//               >
//                 ✕
//               </button>
//             </div>

//             <form onSubmit={handleSubmit} style={{
//               display: 'flex',
//               flexDirection: 'column',
//               gap: '12px',
//               marginTop: '16px'
//             }}>
//               <input
//                 type="text"
//                 name="type"
//                 placeholder="Coupon Type"
//                 value={formData.type}
//                 onChange={handleChange}
//                 required
//                 style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
//               />
//               <textarea
//                 name="description"
//                 placeholder="Description"
//                 value={formData.description}
//                 onChange={handleChange}
//                 rows="3"
//                 required
//                 style={{ ...inputStyle, resize: 'vertical', fontSize: 'clamp(12px, 2vw, 14px)' }}
//               />
//               <input
//                 type="text"
//                 name="gole"
//                 placeholder="Goal (e.g., Increase Leads)"
//                 value={formData.gole}
//                 onChange={handleChange}
//                 required
//                 style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
//               />

//               <div style={{
//                 display: 'flex',
//                 flexDirection: window.innerWidth < 480 ? 'column' : 'row',
//                 gap: '12px'
//               }}>
//                 <div style={{ flex: 1 }}>
//                   <label style={labelStyle}>
//                     Start Date
//                     <input
//                       type="date"
//                       name="startDate"
//                       value={formData.startDate}
//                       onChange={handleChange}
//                       required
//                       style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
//                     />
//                   </label>
//                 </div>
//                 <div style={{ flex: 1 }}>
//                   <label style={labelStyle}>
//                     End Date
//                     <input
//                       type="date"
//                       name="endDate"
//                       value={formData.endDate}
//                       onChange={handleChange}
//                       required
//                       style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
//                     />
//                   </label>
//                 </div>
//               </div>

//               <input
//                 type="number"
//                 name="discount"
//                 placeholder="Discount (%)"
//                 value={formData.discount}
//                 onChange={handleChange}
//                 required
//                 style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
//               />
//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={handleImageUpload}
//                 style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
//               />

//               <button
//                 type="submit"
//                 style={{
//                   padding: '12px',
//                   backgroundColor: '#1976d2',
//                   color: 'white',
//                   fontWeight: 'bold',
//                   border: 'none',
//                   borderRadius: '6px',
//                   cursor: 'pointer',
//                   width: 'fit-content',
//                   fontSize: 'clamp(12px, 2vw, 14px)'
//                 }}
//               >
//                 Submit Request
//               </button>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// // Reusable styles
// const inputStyle = {
//   padding: '10px',
//   border: '1px solid #ccc',
//   borderRadius: '6px',
//   width: '100%',
//   boxSizing: 'border-box',
// };

// const labelStyle = {
//   fontSize: 'clamp(12px, 2vw, 14px)',
//   marginBottom: '4px',
//   display: 'block',
// };

// const tdStyle = {
//   padding: '10px',
//   border: '1px solid #ccc',
//   textAlign: 'left',
// };

// export default Management5;



import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLoader } from "../../../../context/LoaderProvider.jsx";
const Management5 = () => {
  const [formData, setFormData] = useState({
    type: "",
    description: "",

    gole
      : "",
    startDate: "",
    endDate: "",
    discount: "",
    image: "",
  });

  const [couponRequests, setCouponRequests] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const isMobile = window.innerWidth <= 768;
  const [payNowModal, setPayNowModal] = useState(false);
  const { showLoader, hideLoader } = useLoader();

  const [loading, setLoading] = useState(true);

  const tdStyle = {
    border: "1px solid #ccc",
    padding: "10px",
    textAlign: "left",
  };


  const [payNowAmount, setPayNowAmount] = useState(0);
  const [loadingPayNow, setLoadingPayNow] = useState(false);
  const [selectedCouponId, setSelectedCouponId] = useState(null);


  const handleRazorpayPayment = async () => {
    try {
      const vendorId = localStorage.getItem("vendorId");
      const token = localStorage.getItem("authToken");

      // ✅ Step 0: Fetch vendor details (ownerName, email, mobileNumber)
      const vendorRes = await axios.get(
        `https://backend.maamaas.com/food/api/vendors/${vendorId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const vendorData = vendorRes.data;
      const vendorMobile =
        vendorData?.mobileNumber && vendorData.mobileNumber.toString().trim() !== ""
          ? vendorData.mobileNumber.toString()
          : "9999999999"; // fallback if missing

      const vendorName =
        vendorData?.ownerName && vendorData.ownerName.trim() !== ""
          ? vendorData.ownerName
          : "Vendor";

      const vendorEmail =
        vendorData?.email && vendorData.email.trim() !== ""
          ? vendorData.email
          : "vendor@example.com";

      // ✅ Step 1: Prepare payment details
      const payNowAmountInPaise = Math.round(payNowAmount);

      const username = "rzp_live_RU5whSMu9rPV7s"; // Razorpay test key
      const password = "khRC0vtSHCGHktyu62yekZp0"; // Razorpay test secret
      const basicAuth = btoa(`${username}:${password}`);

      // ✅ Step 2: Create Razorpay Order via backend
      const createOrderRes = await axios.post(
        "http://10.10.20.9:6363/subscription-0.0.1-SNAPSHOT/api/user/create-order",
        {
          amount: payNowAmountInPaise,
          currency: "INR",
          vendorId,
        },
        {
          headers: {
            Authorization: `Basic ${basicAuth}`,
            "Content-Type": "application/json",
          },
        }
      );

      const { orderId } = createOrderRes.data;
      if (!orderId) throw new Error("Order ID not received from backend");

      // ✅ Step 3: Open Razorpay Checkout
      const options = {
        key: username,
        amount: payNowAmountInPaise,
        currency: "INR",
        name: "Maamaa's",
        description: "Coupon Payment",
        order_id: orderId,
        handler: async (response) => {
          const paymentId = response.razorpay_payment_id;
          const razorpayOrderId = response.razorpay_order_id;

          if (!paymentId || !razorpayOrderId) {
            alert("⚠️ Payment ID or Order ID missing.");
            return;
          }

          try {
            // ✅ Step 4: Capture payment via backend
            await axios.post(
              "http://10.10.20.9:6363/subscription-0.0.1-SNAPSHOT/api/user/capture",
              {
                paymentId,
                amount: payNowAmountInPaise,
                currency: "INR",
                vendorId,
              },
              {
                headers: { Authorization: `Basic ${basicAuth}` },
              }
            );

            // ✅ Step 5: Update internal backend
            await axios.put(
              `https://backend.maamaas.com/food/api/vendor/coupon/updatePayment`,
              {},
              {
                params: {
                  vendorRequirementCouponId: selectedCouponId,
                  transactionId: paymentId,
                  orderId: razorpayOrderId,
                },
                headers: { Authorization: `Bearer ${token}` },
              }
            );

            alert("Payment successful and updated!");
            window.location.reload();
            setPayNowModal(false);
          } catch (captureError) {
            console.error("❌ Payment capture failed:", captureError);
            alert("Payment saved but capture failed.");
          }
        },
        prefill: {
          name: vendorName, // ✅ ownerName from backend
          email: vendorEmail, // ✅ email from backend
          contact: vendorMobile, // ✅ mobileNumber from backend (no +91)
        },
        theme: { color: "#b15cd6" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error("❌ Razorpay error:", error);
      alert("Payment failed to initialize.");
    }
  };


  const openPayNowModal = async (couponId) => {
    try {
      setLoadingPayNow(true);
      const token = localStorage.getItem("authToken");

      const response = await axios.get(
        `https://backend.maamaas.com/food/api/vendor/coupon/get/${couponId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setPayNowAmount(response.data.amount || 0);
      setSelectedCouponId(couponId); // ✅ save for payment update
      setPayNowModal(true);
    } catch (error) {
      console.error("❌ Error fetching coupon amount:", error);
      alert("Failed to fetch coupon amount");
    } finally {
      setLoadingPayNow(false);
    }
  };



  // ✅ Fetch coupons on mount
  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        showLoader();
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");

        if (!token || !vendorId) {
          alert("Missing vendor session. Please log in again.");
          setLoading(false);
          return;
        }

        const response = await axios.get(
          `https://backend.maamaas.com/food/api/vendor/coupon/getByVendor/${vendorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "*/*",
            },
          }
        );

        // console.log("✅ Coupons fetched:", response.data);

        setCouponRequests(response.data || []);
      } catch (error) {
        console.error("❌ Error fetching coupons:", error);
        alert("Failed to fetch coupon requests");
      } finally {
        setLoading(false);
        hideLoader();
      }
    };

    fetchCoupons();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      let result = reader.result;

      // ✅ Ensure only base64 part (after comma)
      const base64Data = result.split(",")[1];

      setFormData((prev) => ({
        ...prev,
        image: base64Data, // pure base64 string only
      }));
    };
    reader.readAsDataURL(file);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      let authtoken = localStorage.getItem("authToken");
      let vendorId = localStorage.getItem("vendorId");

      if (!authtoken || !vendorId) {
        alert("Missing vendor session. Please log in again.");
        return;
      }

      // ✅ Construct payload with all fields
      const newRequest = {
        vendorRequirementCouponId: 0,
        couponCode: formData.type?.toUpperCase().slice(0, 6) || "DEFAULT",
        discount: Number(formData.discount) || 0,
        startDate: new Date(formData.startDate).toISOString(),
        endDate: new Date(formData.endDate).toISOString(),
        description: formData.description || "",
        gole: formData.gole || "",
        amount: 0, // default if not needed
        paymentStatus: "PENDING",
        vendorId: "null",
        transactionId: "string",
        orderId: "string", // default placeholder
        image: formData.image || "", // ✅ base64 string
      };

      // console.log("📤 Sending payload:", newRequest);

      const response = await axios.post(
        `https://backend.maamaas.com/food/api/vendor/coupon/add/${vendorId}`,
        newRequest,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authtoken}`,
          },
        }
      );

      // console.log("✅ Coupon submitted:", response.data);
      window.location.reload();
      // Reset
      setFormData({
        type: "",
        description: "",
        goal: "",
        startDate: "",
        endDate: "",
        discount: "",
        image: "",
      });
      setShowModal(false);
    } catch (error) {
      console.error("❌ Error submitting coupon:", error.response?.data || error.message);
      alert("Failed to submit coupon. Please check server logs.");
    }
  };




  return (
    <div
      style={{
        // padding: '20px',
        maxWidth: '1200px',
        // margin: isMobile ? '38px 0 0 -29px' : 'auto',
        boxSizing: 'border-box',
        position: 'relative',
        width: '100%',
      }}
    >
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px'
      }}>
        <button
          style={{
            padding: '10px 16px',
            backgroundColor: '#1976d2',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: 'clamp(12px, 2vw, 14px)',
          }}
          onClick={() => setShowModal(true)}
        >
          + Request Coupon
        </button>
      </div>

      {/* Table Section */}
      <div style={{
        marginTop: '-15px',
        overflowX: 'auto',   // Horizontal scroll
        overflowY: 'auto',   // Vertical scroll
        width: window.innerWidth < 769 ? "90vw" : '100%',
        height: '60vh',
        scrollbarWidth: 'thin', // For Firefox
        msOverflowStyle: 'auto', // For IE/Edge
      }}
      >
        <div style={{
          minWidth: '800px',
          width: '100%'
        }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              backgroundColor: "white",
              border: "1px solid rgba(204, 204, 204, 1)",
              marginTop: "0px",
            }}
          >
            <thead>
              <tr>
                {[
                  "S.No",
                  "Type",
                  "Description",
                  "Image",
                  "Goal",
                  "Start Date",
                  "End Date",
                  "Discount",
                  "Amount",
                  "Status",
                  "Action",
                ].map((head, i) => (
                  <th
                    key={i}
                    style={{
                      border: "1px solid #ccc",
                      padding: "10px",
                      backgroundColor: "#b15cd6",
                      fontSize: "clamp(10px, 2vw, 14px)",
                      textAlign: "left",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {head}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="9" style={{ textAlign: "center", padding: "12px" }}>
                    Loading...
                  </td>
                </tr>
              ) : couponRequests.length === 0 ? (
                <tr>
                  <td colSpan="9" style={{ textAlign: "center", padding: "12px" }}>
                    No requests yet.
                  </td>
                </tr>
              ) : (
                couponRequests.map((request, index) => (
                  <tr key={index}>
                    <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                      {index + 1}
                    </td>
                    <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                      {request.couponCode}
                    </td>
                    <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                      {request.description}
                    </td>
                    <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                      {request.image ? (
                        <img
                          src={`data:image/png;base64,${request.image}`} // 👈 show base64 as image
                          alt="Coupon"
                          style={{
                            width: "60px",
                            height: "60px",
                            objectFit: "cover",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                          }}
                        />
                      ) : (
                        "No Image"
                      )}
                    </td>

                    <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                      {request.gole || "N/A"}
                    </td>
                    <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                      {request.startDate ? new Date(request.startDate).toLocaleDateString("en-GB") : "-"}
                    </td>
                    <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                      {request.endDate ? new Date(request.endDate).toLocaleDateString("en-GB") : "-"}
                    </td>

                    <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                      {request.discount}%
                    </td>
                    <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                      {request.amount}
                    </td>
                    <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                      {request.paymentStatus || "Pending"}
                    </td>
                    <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                      {request.paymentStatus === "PAID" ? (
                        <button
                          style={{
                            backgroundColor: "gray",
                            color: "white",
                            border: "1px solid #ddd", // ✅ added border
                            padding: "6px 12px",
                            borderRadius: "6px",
                            cursor: "not-allowed",
                          }}
                          disabled
                        >
                          Paid
                        </button>
                      ) : (
                        <button
                          style={{
                            backgroundColor: "#b15cd6",
                            color: "white",
                            border: "1px solid #b15cd6", // ✅ added border matching button
                            padding: "6px 12px",
                            borderRadius: "6px",
                            cursor: "pointer",
                            whiteSpace: "nowrapyy"
                          }}
                          onClick={() => openPayNowModal(request.vendorRequirementCouponId)}
                        >
                          Pay Now
                        </button>
                      )}
                    </td>




                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>


      {payNowModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            height: '100vh',
            width: '100vw',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: '#fff',
              padding: '20px',
              borderRadius: '10px',
              width: '90%',
              maxWidth: '400px',
              boxSizing: 'border-box',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: 'bold' }}>Pay Now</h3>
              <button
                style={{
                  background: 'transparent',
                  border: 'none',
                  fontSize: '18px',
                  cursor: 'pointer',
                }}
                onClick={() => setPayNowModal(false)}
              >
                ✕
              </button>
            </div>

            <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {loadingPayNow ? (
                <p>Loading amount...</p>
              ) : (
                <label style={labelStyle}>
                  Amount
                  <input
                    type="number"
                    value={payNowAmount}
                    readOnly
                    style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                  />
                </label>
              )}

              <button
                style={{
                  padding: '12px',
                  backgroundColor: '#1976d2',
                  color: 'white',
                  fontWeight: 'bold',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  width: 'fit-content',
                  fontSize: 'clamp(12px, 2vw, 14px)'
                }}
                onClick={handleRazorpayPayment} // ✅ call payment function
              >
                Proceed to Pay
              </button>

            </div>
          </div>
        </div>
      )}



      {/* Modal Popup */}
      {showModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            height: '100vh',
            width: '100vw',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: '#fff',
              padding: '20px',
              borderRadius: '10px',
              width: '90%',
              maxWidth: '600px',
              maxHeight: '90vh',
              overflowY: 'auto',
              boxSizing: 'border-box',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: 'bold' }}>Request a Coupon</h3>
              <button
                style={{
                  background: 'transparent',
                  border: 'none',
                  fontSize: '18px',
                  cursor: 'pointer',
                }}
                onClick={() => setShowModal(false)}
              >
                ✕
              </button>
            </div>

            <form onSubmit={handleSubmit} style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              marginTop: '16px'
            }}>
              <input
                type="text"
                name="type"
                placeholder="Coupon Type"
                value={formData.type}
                onChange={handleChange}
                required
                style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
              />
              <textarea
                name="description"
                placeholder="Description"
                value={formData.description}
                onChange={handleChange}
                rows="3"
                required
                style={{ ...inputStyle, resize: 'vertical', fontSize: 'clamp(12px, 2vw, 14px)' }}
              />
              <input
                type="text"
                name="gole"
                placeholder="Goal (e.g., Increase Leads)"
                value={formData.gole}
                onChange={handleChange}
                required
                style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
              />

              <div style={{
                display: 'flex',
                flexDirection: window.innerWidth < 480 ? 'column' : 'row',
                gap: '12px'
              }}>
                <div style={{ flex: 1 }}>
                  <label style={labelStyle}>
                    Start Date
                    <input
                      type="date"
                      name="startDate"
                      value={formData.startDate}
                      min={new Date().toISOString().split('T')[0]}

                      onChange={handleChange}
                      required
                      style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                    />
                  </label>
                </div>
                <div style={{ flex: 1 }}>
                  <label style={labelStyle}>
                    End Date
                    <input
                      type="date"
                      name="endDate"
                      value={formData.endDate}
                      onChange={handleChange}
                      min={formData.startDate || new Date().toISOString().split('T')[0]}

                      required
                      style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                    />
                  </label>
                </div>
              </div>

              <input
                type="number"
                name="discount"
                placeholder="Discount (%)"
                value={formData.discount}
                onChange={handleChange}
                required
                style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
              />
              <input
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
              />

              <button
                type="submit"
                style={{
                  padding: '12px',
                  backgroundColor: '#1976d2',
                  color: 'white',
                  fontWeight: 'bold',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  width: 'fit-content',
                  fontSize: 'clamp(12px, 2vw, 14px)'
                }}
              >
                Submit Request
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

// Reusable styles
const inputStyle = {
  padding: '10px',
  border: '1px solid #ccc',
  borderRadius: '6px',
  width: '100%',
  boxSizing: 'border-box',
};

const labelStyle = {
  fontSize: 'clamp(12px, 2vw, 14px)',
  marginBottom: '4px',
  display: 'block',
};

const tdStyle = {
  padding: '10px',
  border: '1px solid #ccc',
  textAlign: 'left',
};

export default Management5;